import list from "store/modules/entities/offerCommissions/list"
import overview from "store/modules/entities/offerCommissions/overview"
import { combineReducers } from "redux"

export default combineReducers({
  list,
  overview
})
